import { Controller } from "@hotwired/stimulus"
import { createElement, csrfToken, debounce } from "../helpers"

const NOTIFY_DELAY = 1000

export default class extends Controller {
  static values = { path: String, kind: String }

  initialize() {
    this.notifyUser = debounce(this.notifyUser.bind(this), NOTIFY_DELAY)
  }

  toggle({ currentTarget }) {
    const pressed = currentTarget.ariaPressed != "true"
    currentTarget.ariaPressed = pressed
    this.performToggle(currentTarget, pressed ? "add" : "remove")
    this.notifyUser()
  }

  async performToggle(el, type) {
    el.toggleAttribute("data-toggling", true)
    await this[`${type}Absence`](el.dataset.date)
    el.toggleAttribute("data-toggling", false)
  }

  addAbsence(date) {
    const options = {
      method: "post",
      headers: {
        "X-CSRF-Token": csrfToken(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        date: date,
      }),
    }
    return fetch(this.pathValue, options)
  }

  notifyUser() {
    if (!this.toast?.hasAttribute("visible")) {
      this.toast = createElement("toast-notification", { textContent: this.notification })
      document.body.append(this.toast)
    }
  }

  get notification() {
    return this.kindValue == "team" ? "Holidays updated" : "Absences updated"
  }

  removeAbsence(date) {
    const options = {
      method: "delete",
      headers: {
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify({
        date: date,
      }),
    }
    return fetch(`${this.pathValue}/${date}`, options)
  }
}
